function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CloseIcon } from '@domain-group/fe-co-icon';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
var promoImage = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-pa-allhomes-listing-search-results/static/property-alerts-promo_2e511c59.svg";
import * as styles from './onboarding-popup.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
class OnboardingPopup extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "closePopup", evt => {
      if (this.containerRef && !this.containerRef.contains(evt.target)) {
        this.props.onClose();
      }
    });
    _defineProperty(this, "displayCreatePopup", () => {
      this.props.displayCreatePopup();
    });
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    if (typeof document !== 'undefined') {
      document.addEventListener('mousedown', this.closePopup, false);
    }
  }
  componentWillUnmount() {
    if (typeof document !== 'undefined') {
      document.removeEventListener('mousedown', this.closePopup, false);
    }
  }
  render() {
    var onClose = this.props.onClose;
    return ___EmotionJSX("div", {
      css: styles.popup,
      ref: containerRef => {
        this.containerRef = containerRef;
      }
    }, ___EmotionJSX("button", {
      "aria-label": "close",
      type: "button",
      onClick: onClose,
      css: styles.closeButton
    }, ___EmotionJSX(CloseIcon, {
      size: "small"
    })), ___EmotionJSX("div", {
      css: styles.content
    }, ___EmotionJSX("span", null, ___EmotionJSX("img", {
      src: promoImage,
      width: "80",
      height: "73",
      alt: ""
    })), ___EmotionJSX("div", {
      css: styles.contentMiddle
    }, ___EmotionJSX("div", {
      css: styles.title
    }, "Keep up with this search"), ___EmotionJSX("div", {
      css: styles.message
    }, "Tap the bell and we'll email you when new properties match this search."), ___EmotionJSX("div", {
      css: styles.buttonGroup
    }, ___EmotionJSX(Button, {
      css: styles.button,
      appearance: "ghost",
      onClick: this.displayCreatePopup
    }, "Try it out")))));
  }
}
OnboardingPopup.propTypes = {
  onClose: PropTypes.func,
  displayCreatePopup: PropTypes.func.isRequired
};
OnboardingPopup.defaultProps = {
  onClose: () => {}
};
export default OnboardingPopup;